import { PolicyStatus, PolicyType } from "../policies/Policies.types";
import { BaseViewModel } from "../../system/systemOverview/SystemOverview.types";
import { SelectableItem, SelectableProcessingActivityItem } from "../../processingActivity/ProcessingActivity.types";
import { PolicyVersionSummary } from "../policyCompareVersions/PolicyCompareVersions.types";

export interface PolicyViewModel {
    type: PolicyType;
    name: string;
    description?: string | null;
    responsible?: BaseViewModel | null;
    approver?: BaseViewModel | null;
    status: PolicyStatus;
    unarchiveStatus: PolicyStatus;
    versionMajor?: number | null;
    versionMinor?: number | null;
    displayVersion?: string | null;
    currentApprovedMajor?: number | null;
    currentApprovedMinor?: number | null;
    sectionCount: number;
    controlCount: number;
    controlIds: Array<string>;
    receiptsCompleted: number;
    receiptsTotal: number;
    numberOfDocuments: number;
    hasDraft: boolean;
    versions: Array<PolicyVersionSummary>;
    note?: string | null;
    publicLinkId?: string | null;
    isPublicShared: boolean;
    tags: Array<BaseViewModel>;
    processingActivities: Array<SelectableProcessingActivityItem>;
    systems: Array<SelectableItem>;
    noOfProcessingActivitiesWithNoAccess?: number | null;
    noOfSystemsWithNoAccess?: number | null;
}

export enum PolicyPlanTabId {
    Documents = "documents",
    Tasks = "tasks",
    Sections = "sections",
    Recipients = "recipients",
    VersionsHistory = "versionHistory",
}
